import { Action } from "src/types";

export const SET_CURRENT_FLOW_STEP = "SET_CURRENT_FLOW_STEP";

export const setCurrentFlowStep = (flowName: string, step: number): Action => ({
    type: SET_CURRENT_FLOW_STEP,
    payload: { [flowName]: step }
});
